<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Banka</label>
            <v-select-list v-model="bank" :disabled="(banks || []).length == 0" placeholder="Banka" label="Name" :options="banks"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Hesap Numarası</label>
            <input type="text" v-model="value.AccountNumber" class="form-control" placeholder="Hesap Numarası"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Banka Şube Kodu</label>
            <input type="text" v-model="value.BranchNumber" class="form-control" placeholder="Banka Şube Kodu"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Hesap Adı</label>
            <input type="text" v-model="value.Name" class="form-control" placeholder="Hesap Adı"/>
        </div>
         <div class="col-12 mb-1">
            <label class="form-label">Açıklama Tipi</label>
            <v-select-list v-model="descriptionType" :disabled="(descriptionTypes || []).length == 0" placeholder="Açıklama Tipi" label="Value" :options="descriptionTypes"/>
        </div>
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters'

export default {
    props:{
        value:Object,
    },
    data(){
        return {
            banks:[],
            descriptionTypes:[],
        }
    },
    mounted(){
        this.getBanks(),
        this.getDescriptionTypes()
    },
    methods:{
        getBanks(){
            HumanResourcesParameterApi.Bank.List().then(res=>{
                this.banks = res.data.Data
            })
        },
        getDescriptionTypes(){
            HumanResourcesParameterApi.Bank.ListDescriptionTypes().then(res=>{
                this.descriptionTypes = res.data.Data
            })
        },
    },
    computed:{
        bank:{
            get:function(){
                return this.banks.find(b=>b.Id==this.value.BankId)
            },
            set:function(value){
                this.value.BankId = value?.Id || null
            }
        },
        descriptionType:{
            get:function(){
                return this.descriptionTypes.find(d=>d.Key==this.value.DescriptionTypeId)
            },
            set:function(value){
                this.value.Key = value?.Key ?? null
                this.value.DescriptionTypeId = value?.Key ?? null
            }
        },
    }
}
</script>

<style>

</style>